import React from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from '@hero/schema';
import { useOrderTimeline } from '@hero/hooks-shared';
import { TimelineStepComponent } from './TimelineStep';

export interface OrderTimelineProps {
  order: Order;
  displayForUser: 'customer' | 'carrier';
}

export const OrderTimeline: React.FC<OrderTimelineProps> = ({ order, displayForUser }) => {
  const { t } = useTranslation('m-order');

  const { steps: timelineSteps } = useOrderTimeline({
    order,
    displayForUser,
  });

  return (
    <div>
      <h3 className="mt-6 text-[18px] font-[600] leading-[28px] text-black text-start">
        {t('timeline.title')}
      </h3>
      <div className="relative flex flex-col gap-4 mt-4 px-2 py-1">
        <div className="z-1 absolute start-[25px] top-[30px] h-[calc(100%-54px)] w-0 border-s-[1.5px] border-dotted border-gray-300" />

        {timelineSteps.map((step, index) => (
          <TimelineStepComponent
            key={`${step.stepId}-${index}`}
            stepId={step.stepId}
            labelKey={step.labelKey}
            activeLabelKey={step.activeLabelKey}
            status={step.status}
            occurred={step.occurred}
            inProgress={step.inProgress}
            date={step.date}
            orderRef={order.ref.short}
            isFirst={index === 0}
          />
        ))}
      </div>
    </div>
  );
};
